import { useEffect } from "react";
import { withRouter } from "react-router-dom";

const ScrollToTop = (props) => {
  useEffect(() => {
    const { hash } = props.location;
    if (hash && hash.length > 1) {
      const id = hash.replace("#", "");
      const el = document.getElementById(id);
      if (el) {
        window.requestAnimationFrame(() => {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [props.location]);

  return props.children;
};

export default withRouter(ScrollToTop);
